export default function getGetCheckOrderDataUrl() {
    let checkOrderUrl = window.location.href.split('#')[0];
    // add time param to avoid browser caching
    if (checkOrderUrl.includes("?")) {
        checkOrderUrl = `${checkOrderUrl}&time=${new Date().getTime()}`;
    } else {
        checkOrderUrl = `${checkOrderUrl}?time=${new Date().getTime()}`;
    }

    return checkOrderUrl
}